<div class="fixed inset-0 z-[80] bg-black/50">

    <div
        class="fixed top-0 right-0 h-full w-full max-w-[500px]
            bg-background shadow-2xl p-4
            transition-transform duration-300
            flex flex-col min-h-0
            "
    >
        <!-- header -->
        <div class="shrink-0 flex flex-row justify-between items-center border-b border-primary pb-4 mb-5">
            <h5 id="drawer-right-title" class="inline-flex items-center text-lg font-bold text-body">
                {{title}}
            </h5>

            <div>
                <button
                    type="button"
                    aria-label="Close drawer"
                    class="cursor-pointer text-body bg-transparent hover:text-heading hover:bg-neutral-tertiary rounded-base w-9 h-9 flex items-center justify-center"
                    (click)="close()"
                    >
                    X
                </button>
            </div>
        </div>

        <!-- dynamic component -->
        <div class="flex-1 min-h-0 overflow-y-auto pe-1">
            <ng-container #content></ng-container>
        </div>

    </div>
</div>
